import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.dashboard.pending_title',
        defaultMessage: 'We won’t be a minute!'
    },
    subtitle: {
        id: '_.dashboard.pending_subtitle',
        defaultMessage:
            'Thanks for signing up to use iwocaPay! We just need to review your details. If we’ve received your request during working hours (Mon - Fri, 9am - 6pm) we’ll get back to you within a few hours, otherwise it will be within 2 hours of the next working day.' +
            'Get in touch on 0203 778 0549.'
    }
});
